import { createContext, useContext } from 'react'

interface PageHeaderContextType {
  alternativeHeader: boolean
}

export const PageHeaderContext = createContext<PageHeaderContextType | undefined>({
  alternativeHeader: false,
})

export function usePageHeaderContext() {
  return useContext(PageHeaderContext)
}
